import React from 'react'

import { PageTitle } from "../../../../../_template/layout/core/PageData";

const AgentReport = () => {

    const agentProfileTitle = [
        {
            title: 'Report',
            path: '/admin/report/chat-report',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];
    return (
        <>
            <PageTitle breadcrumbs={agentProfileTitle}>Agent Report</PageTitle>
            <div>AgentReport</div>
        </>
        
    )
}

export {AgentReport}